import cities from '../database/cities.js';
import {get} from 'svelte/store';

const cityLocalizer = (string, city) => {
    let result = null;
    let regex = /#city#/g;
    const cityData = get(cities);

    if (string === null || typeof string === undefined || city === null || typeof city === undefined) return '';

    if (city === '') {
        city = 'global';
    }

    result = string.replace(regex, cityData[city]?.name || '');

    regex = /#cityLocativeInUrl#/g;
    result = result.replace(regex, cityData[city]?.locativeInUrl || '');

    regex = /#cityLocativeIn#/g;
    result = result.replace(regex, cityData[city]?.locativeIn || '');

    regex = /#cityLocativeInDefault#/g;
    result = result.replace(regex, cityData[city]?.locativeIn || 'w Toruniu');

    if ((cityData[city]?.locative || '') !== '') {
        regex = /#cityLocativeSlash#/g;
        result = result.replace(regex, '/ ' + (cityData[city]?.name || ''));
    }

    regex = /#cityLocative#/g;
    result = result.replace(regex, cityData[city]?.locative || '');

    regex = /#cityIdUrl#/g;
    result = result.replace(regex, (cityData[city]?.id ? '/' : '') + cityData[city]?.id);

    regex = /#cityIdUrlBeforeDash#/g;
    result = result.replace(regex, (cityData[city]?.id ? '-' : '') + cityData[city]?.id);

    regex = /#cityIdUrlDash#/g;
    result = result.replace(regex, cityData[city]?.id + (cityData[city]?.id ? '-' : ''));


    return result;
}

export default cityLocalizer;